/**
 * Serializacion JSON canonica: claves ordenadas y sin `undefined`. Dos valores
 * equivalentes producen siempre el mismo texto (y por tanto la misma huella).
 *
 * @example canonicalJson({ b: 1, a: [2, undefined] }) // '{"a":[2,null],"b":1}'
 */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(sortKeys(value));
}

function sortKeys(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(sortKeys);
  if (value !== null && typeof value === 'object') {
    const entries = Object.entries(value)
      .filter(([, child]) => child !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return Object.fromEntries(entries.map(([key, child]) => [key, sortKeys(child)]));
  }
  return value;
}

/** Bytes UTF-8 de un texto. */
export const utf8Length = (text: string): number => new TextEncoder().encode(text).length;
